@if (jobListExists) {
  <div class="p-2 py-3 p-lg-2 text-body user-stat-card">
    <dt>Alarm Responses</dt>
    @if (staleDataCheck && !refreshBtnPressed) {
      <div
        class="d-flex alert alert-info small align-items-center justify-content-between"
      >
        <span> Last updated {{ staleDataCheck }} mins ago.</span>
        <button class="btn btn-secondary btn-sm" (click)="refreshData()">
          <i class="fa-solid fa-arrow-rotate-right"></i> Refresh
        </button>
      </div>
    }
    @if (refreshCalled) {
      <div
        class="d-flex alert alert-info small align-items-center justify-content-between"
      >
        <span> Showing latest data</span>
      </div>
    }

    <gtapp-gt-custom-table
      [deskTopTableData]="jobListData"
      [desktopTableDetails]="jobListTableDetails"
      [tableStyle]="{
        'overflow': 'auto',
        'max-height': '40vh',
      }"
      [otherParams]="otherParamsLiveResponses"
      (rowClick)="routeToJob($event)"
      (paginationChange)="onChangePaginationLiveResponses($event)"
      (sortColumn)="sortColumnLiveResponses($event)"
      (searchColumn)="searchColumnLiveResponses($event)"
    >
    </gtapp-gt-custom-table>
  </div>
}
